<template>
    <div>
        <navigation-bar Close/>
        <div class="main">
            <item-grid class="two-gird">
                <!--TODO:推薦餐點清單-->
                <commodity-item :list="commodityList" :routerName="'MealInfo'" :type="type"/>
            </item-grid>

            <infinite-loading @infinite="setupDataScroll" spinner="waveDots">
                <div slot="no-more">沒有更多資料</div>
                <span slot="no-results"/>
            </infinite-loading>

            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true"
                    v-if="Datasetup"
            >
            </loading>
        </div>
    </div>

</template>

<script>
    import ItemGrid from '@/components/category/ItemGrid.vue';
    import CommodityItem from '@/views/store/components/CommodityItem.vue';
    import {notNull} from "@/util/common";
export default {
    name: 'CommodityList',
    components: {
        ItemGrid,
        CommodityItem,
    },
    data() {
        return {
            commodityList: [],
            id: this.$route.query.id ? Number(this.$route.query.id) : 0,
            type: this.$route.query.type ? this.$route.query.type : '',
            pageSize: 10,
            currentPage: 0,
            isLoading: false,
            Datasetup: true,
        }
    },
    created() {
    },
    methods:{
        setupDataScroll: function ($state) {
            //好友串門子
            this.isLoading = true;
            
            this.$http.fetch`GetCommodityList${{
                offset: this.currentPage,
                id: this.id,
                type: this.type,
            }}
            ${json => {
                if (notNull(json.data)) {
                    if (json.data.length >= this.pageSize) {
                        this.currentPage++;
                        this.commodityList.tmz_load_push(...json.data);
                        $state.loaded();
                    } else {
                        this.currentPage++;
                        this.commodityList.tmz_load_push(...json.data);
                        $state.complete();
                    }
                }
                this.isLoading = false;
            }}`;
        },
    },
}
</script>
<style lang="less" scoped>
    .content{
        padding-bottom: 100px;
    }
</style>